module.exports = __webpack_public_path__ + "img/gift-box-right.7b860d0f.svg";